import React from 'react';

import styled from 'styled-components';

import { useBuilderConstructorCategoryNav } from '~/builder/utils/useBuilderConstructorCategoryNav';
import { Link } from '~/techstyle-shared/next-routes';
import { slugify } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

import useBuilderConstructorGridInputs from '../../hooks/useBuilderConstructorGridInputs';

const DynamicFormattedMessage = FormattedMessage;

const BreadcrumbsList = styled.ul`
  display: flex;
  gap: 4px;
  list-style: none;
`;

const BreadcrumbsListItemActive = styled.li`
  font-size: 14px;
  font-weight: 600;
`;

const BreadcrumbsListItem = styled.li`
  font-size: 14px;
  font-weight: 400;
  display: flex;
  gap: 4px;
`;

const BreadcrumbsListItemLink = styled.a`
  color: ${({ theme }) => theme.colors.gridBreadcrumbTextColor};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const DesktopSideNavBreadcrumbs = () => {
  const { sideNav } = useBuilderConstructorGridInputs();

  const clientCategoryNavSettings = useBuilderConstructorCategoryNav({
    sideNav,
  });

  const breadcrumbs = clientCategoryNavSettings?.breadcrumbs;

  if (!breadcrumbs?.length) {
    return null;
  }

  return (
    <BreadcrumbsList>
      {breadcrumbs?.map((breadcrumb, index) => {
        const isActive = index === breadcrumbs.length - 1;
        const layerIndex = index + 1;
        return isActive ? (
          <BreadcrumbsListItemActive
            key={breadcrumb?.urlPath}
            data-autotag={`grid-breadcrumb-layer-${layerIndex}`}
          >
            <DynamicFormattedMessage
              id={`site_product_category.${slugify(breadcrumb.label, '_')}`}
              defaultMessage={breadcrumb.label}
            />
          </BreadcrumbsListItemActive>
        ) : (
          <BreadcrumbsListItem
            key={breadcrumb?.urlPath}
            data-autotag={`grid-breadcrumb-layer-${layerIndex}`}
          >
            <Link href={breadcrumb?.urlPath}>
              <BreadcrumbsListItemLink>
                <DynamicFormattedMessage
                  id={`site_product_category.${slugify(breadcrumb.label, '_')}`}
                  defaultMessage={breadcrumb.label}
                />
              </BreadcrumbsListItemLink>
            </Link>
            <p>/</p>
          </BreadcrumbsListItem>
        );
      })}
    </BreadcrumbsList>
  );
};

export default DesktopSideNavBreadcrumbs;
